import * as React from 'react';
import { css } from 'emotion';
import theme from '../../../styles/themes/hopeTheme';
/* Components */

interface TextImageBannerProps {
  config: {
    summary: string;
    imgSrc: string;
    imgAlt: string;
  };
}

const container = css`
  text-align: center;
  font-family: ${theme.headerBold};
  background-color: #fafafa;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media screen and (min-width: 769px) {
    padding-bottom: 0;
  }
`;

const flexContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  max-width: 960px;
  padding: 40px 16px;
`;

const summaryText = css`
  color: ${theme.textColor};
  font-size: 16px;
  line-height: 1.5;
  font-weight: 300;
  padding-top: 24px;
`;

function createMarkup(summary: string) {
  return { __html: summary };
}

function TextImageBanner({ config }: TextImageBannerProps) {
  const { imgSrc, imgAlt, summary } = config;
  return (
    <div className={container}>
      <div className={flexContainer}>
        <img src={imgSrc} alt={imgAlt} />
        <div
          className={summaryText}
          dangerouslySetInnerHTML={createMarkup(summary)}
        />
      </div>
    </div>
  );
}

export default TextImageBanner;
